import type { VendorCustomerType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import VendorCustomersTableRow from './VendorCustomersTableRow';

interface VendorCustomersTableBodyProps {
    rows: VendorCustomerType[];
    onEdit: (row: VendorCustomerType) => void;
    onDelete: (row: VendorCustomerType) => void;
}

const VendorCustomersTableBody = ({ rows, onEdit, onDelete }: VendorCustomersTableBodyProps) => {
    return (
        <tbody>
            {!rows.length ? (
                <TableEmptyRow colSpan={4} />
            ) : (
                rows.map((row) => (
                    <VendorCustomersTableRow key={row.ID} row={row} onEdit={onEdit} onDelete={onDelete} />
                ))
            )}
        </tbody>
    );
};

export default VendorCustomersTableBody;
